import { route } from 'preact-router';
import { T } from '@/ui/tokens';
import { Icons } from '@/ui/icons';
import { config } from '@/config';

const TABS = [
  { k: 'home',      label: 'Home',      path: config.routes.home,      icon: Icons.home },
  { k: 'services',  label: 'Services',  path: config.routes.services,  icon: Icons.grid },
  { k: 'orders',    label: 'Orders',    path: config.routes.orders,    icon: Icons.list },
  { k: 'referrals', label: 'Referrals', path: config.routes.referrals, icon: Icons.users },
  { k: 'news',      label: 'News',      path: config.routes.news,      icon: Icons.news },
] as const;

export function BottomTabs({ active, hasNewNews }: {
  active: typeof TABS[number]['k'];
  hasNewNews?: boolean;
}) {
  return (
    <nav style={{
      position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 50,
      paddingBottom: 'var(--safe-bottom, 0px)',
      background: 'rgba(10,12,15,0.85)',
      backdropFilter: 'blur(14px)',
      borderTop: `1px solid ${T.line}`,
    }}>
      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)',
        padding: '8px 6px 10px',
      }}>
        {TABS.map(t => {
          const on = t.k === active;
          return (
            <button key={t.k} onClick={() => route(t.path)} style={{
              background: 'none', border: 'none', cursor: 'pointer',
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
              color: on ? T.accent : T.textMute,
            }}>
              <span style={{ width: 22, height: 22, display: 'inline-flex',
                alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                {t.icon}
                {t.k === 'news' && hasNewNews && (
                  <span style={{
                    position: 'absolute', top: -3, right: -5,
                    width: 8, height: 8, borderRadius: '50%',
                    background: T.accent, boxShadow: `0 0 6px ${T.accent}`,
                  }}/>
                )}
              </span>
              <span style={{ fontSize: 10, fontWeight: on ? 600 : 500, letterSpacing: 0.3 }}>
                {t.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
